<script setup lang="ts">
    import './index.scss';

    const route = useRoute()
    const pathList = computed(() => {
        let fullPathArray = route.fullPath.split('?')[0].split('/').splice(1);
        
        if(fullPathArray[0] == 'restaurants') {
            fullPathArray.splice(2, 1);
        }

        return fullPathArray;
    });
    const pathLength = computed(() => pathList.value.length);

    const navigate = (index: number) => {
        if (index < pathLength.value) {
            const filteredPath = pathList.value.slice(0, index + 1).join('/');
            navigateTo(`/${filteredPath}`);
        }
    };

    const stripDashes = (value: string) => {
        // return value.replace(/-/g, ' ');
        return value.replace(/^\d+_/, '').replace(/-/g, ' ');
    };

    const pageTitle = useState('pageTitle', () => '');
</script>

<template>
    <div class="my-[1.6rem] max-w-[116rem] mx-auto max-md:overflow-x-scroll scrollbar-hide" v-if="pathLength > 1 || !pathList.includes('')">
        <ul class="flex">
            <li class="bread">
                <NuxtLink to="/" class="font-normal text-[secondary] text-[1.4rem] leading-[1.5]">Home</NuxtLink>
            </li>

            <li
                v-for="(value, index) in pathList" :key="'breadcrumb-' + index"
                    :class="[
                        { 'bread text-[secondary]' : index + 1 != pathLength },
                        { 'text-[blueLink]' : index + 1 == pathLength }
                    ]">
                <NuxtLink
                    v-if="index + 1 < pathLength"
                    @click="navigate(index)" 
                    :class="[
                        'font-normal text-[1.4rem] leading-[1.5] capitalize whitespace-nowrap',
                        { 'cursor-pointer' : index + 1 != pathLength },
                        { '!cursor-auto ': index + 1 == pathLength }
                    ]"> 
                        {{ stripDashes(value) }}
                </NuxtLink>
                <!-- For routes that are Ids -->
                <NuxtLink
                    v-else
                    @click="navigate(index)" 
                    :class="[
                        'font-normal text-[1.4rem] leading-[1.5] capitalize whitespace-nowrap',
                        { 'cursor-pointer' : index + 1 != pathLength },
                        { '!cursor-auto ': index + 1 == pathLength }
                    ]"> 
                        {{ (route.params.id && pageTitle) ? stripDashes(pageTitle) : stripDashes(value) }}
                </NuxtLink>
            </li>
        </ul>
    </div>
</template>